(() => {
    "use strict";

    const BOX_SELECTOR = [
        ".catalog-curadoria",
        ".experiencias-contact-card",
        ".faq-curadoria-mini",
        ".mega-menu-curadoria",
    ].join(",");
    const IDLE_MS = 10000;

    let idleTimer = 0;
    let listening = false;
    let shining = false;
    let observer = null;
    const visibleBoxes = new Set();

    function prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function boxes() {
        return [...document.querySelectorAll(BOX_SELECTOR)];
    }

    function watchVisibility(nodes) {
        if (typeof IntersectionObserver !== "function") {
            nodes.forEach((box) => visibleBoxes.add(box));
            return;
        }

        if (!observer) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        visibleBoxes.add(entry.target);
                        return;
                    }

                    visibleBoxes.delete(entry.target);
                    entry.target.classList.remove("is-idea");
                });
            }, { threshold: 0.25 });
        }

        nodes.forEach((box) => observer.observe(box));
    }

    function clearIdea() {
        shining = false;
        boxes().forEach((box) => box.classList.remove("is-idea"));
    }

    function shine() {
        const nodes = boxes();
        if (!nodes.length || prefersReducedMotion()) {
            return;
        }

        watchVisibility(nodes);
        const targets = visibleBoxes.size ? [...visibleBoxes] : nodes;
        targets.forEach((box) => box.classList.add("is-idea"));
        shining = true;
    }

    function onActivity() {
        if (shining) {
            clearIdea();
        }
        arm();
    }

    function arm() {
        window.clearTimeout(idleTimer);
        if (prefersReducedMotion() || !boxes().length) {
            return;
        }
        idleTimer = window.setTimeout(shine, IDLE_MS);
    }

    function bindIdleShine() {
        if (!listening) {
            listening = true;
            document.addEventListener("mousemove", onActivity, { passive: true });
        }
        watchVisibility(boxes());
        arm();
    }

    if (typeof window.siteReady === "function") {
        window.siteReady(bindIdleShine);
        return;
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindIdleShine);
    } else {
        bindIdleShine();
    }
})();
